module.exports = __webpack_public_path__ + "img/Edamam_Badge.1dd98c19.svg";